import { alpha, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { classNames } from "react-extras";
import { useAppSelector } from "~/redux/store/store";

const useStyles = makeStyles((theme) => ({
  positionContainer: {
    position: "absolute",
    bottom: theme.spacing(2),
    zIndex: theme.zIndex.speedDial,
    width: "auto",
    backgroundColor: alpha(theme.palette.primary.main, 0.6),
    color: theme.palette.primary.contrastText,
  },
  hidden: {
    display: "none",
  },
}));
export const CesiumCoordinateTooltip = (): JSX.Element => {
  const classes = useStyles();
  const positionText = useAppSelector((s) => s.map.cesiumCoordinates);
  return (
    <Grid
      container
      className={classNames(classes.positionContainer, {
        [classes.hidden]: !positionText,
      })}
      sx={{
        right: (theme) => ({
          xs: `calc(${theme.spacing(2)} + 56px + ${theme.spacing(2)})`,
          md: theme.spacing(2),
        }),
      }}
    >
      <Typography variant="body2" style={{ whiteSpace: "pre", margin: 5 }}>
        {positionText}
      </Typography>
    </Grid>
  );
};
